import { render } from "./chat-bubble.vue?vue&type=template&id=98e6be8e"
import script from "./chat-bubble.vue?vue&type=script&lang=js"
export * from "./chat-bubble.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__